<template>
  <div :class="['quantitybox', {'quantitybox-small': small}]">
    <button class="btn-minus" :disabled="disableMinus" v-on:click="decrease">
      <i class="fa fa-minus"></i>
    </button>
    <input type="text" autocomplete="off" :value="value" v-on:input="updateValue($event.target.value)"></input>
    <button class="btn-plus"  v-on:click="increase">
      <i class="fa fa-plus"></i>
    </button>
  </div>
</div>
</template>
<script>
export default {
  props: {
    value: {},
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    disableMinus() {
      return this.value === this.min;
    }
  },
  methods: {
    decrease() {
      this.$emit('input', parseInt(this.value) - 1);
    },
    increase() {
      this.$emit('input', parseInt(this.value) + 1);
    },
    updateValue(value) {
      if (typeof value == 'string') {
        value = parseInt(value);
      }

      if (this.max && value > this.max) {
        value = this.max;
      }

      this.$emit('input', value);
    }
  }
}
</script>
